import React, { Component } from 'react';
import { browserHistory } from 'react-router';
// import ImageLink from '../../../../../../components/ZUILib/ImageLink';
import TextInput from '../../../../../../components/ZUILib/TextInput';
// import Label from '../../../../../../components/ZUILib/Label';
import InputButton from '../../../../../../components/ZUILib/InputButton';
// import ImageSelector from '../../../../../../components/ZUILib/ImageSelector';
import Link from '../../../../../../components/ZUILib/Link';
import KalturaFileUpload from '../../../../../../components/KalturaFileUpload';
import commonUtil from './../../../../../../utils/commonUtil';
import Warning from '../../../../../../components/Warning';
import * as eventDetailsActions from '../actions';
import * as defaultConst from './../../../../../../utils/clientConstant';

const { saveEventName } = eventDetailsActions;


const applicationRoutes = commonUtil.getApplicationRoutes();


export default class Header extends Component {
  constructor(props) {
    super(props);
    this.warningMessage = '';
  }
  showDropdown = false

  state = {
    _EventName: '',
    imagePath: '',
  }
  openEditBox = (eventName) => {
    document.querySelector('#eventName').value = eventName;
    document.querySelector('.editEventName').setAttribute('style', 'display:block');
    document.querySelector('#image').style.display = 'none';
    // document.querySelector('.editImage').setAttribute('style', 'display:none');
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.userEventDetails.eventDetailsInfo.eventName) {
      this.cancel();
      this.newEventName = nextProps.userEventDetails.eventDetailsInfo.eventName;
    }
  }
  setValue = (field, e) => {
    switch (field) {
      case 'eventName':
        return this.setState({
          ...this.state,
          eventName: e,
        },
        );
      case 'image':
        return this.setState({
          ...this.state,
          imagePath: e,
        },
        );
      default: break;
    }
    return this.state;
  }

  // image upload functions
  onFileRemoved = () => {
  };
  onError = () => {
  };
  onFileSuccess = (data) => {
    document.querySelector('#croppieImg').src = data.dataUrl;
    const imageURL = data.dataUrl;
    saveEventName(this.eventId, '', imageURL).then((response) => {
      if (response.body.status.status === defaultConst.constAPISuccess) {
        this.props._getEventDetails(this.eventId);
        this.warning.setMessage('');
      }
    }).catch((e) => {
      console.log(e); // console required
    });
  }
  onMaxFileSizeErrorCallback = () => {
    this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
  }
  onMinFileSizeErrorCallback = () => {
    this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
  }
  onFileAddedError = () => {
    this.warning.setMessage('Este archivo de extensión no está permitido.');
  }
  openProfileImageUploader = () => {
    if (document.querySelector('.file-upload')) {
      document.querySelector('.file-upload').click();
    }
  }

  // updateEventName = () => {
  //   if (this.newEventName && this.newEventName !== this.props.userEventDetails.eventDetailsInfo.eventName) {
  //     const eventNameValidationRules = [
  //       { functionRef: commonUtil.validateName, funcData: [this.newEventName, 3], errorMessage: 'El nombre del evento no es válido' },
  //     ];
  //     const validEventName = commonUtil.validateTextInput(eventNameValidationRules, this.eventName, null);
  //     if (validEventName) {
  //       this.props.handleValidateEventName(this.newEventName, this.email, '').then((response) => {
  //         if (response.body.status.status === defaultConst.constAPISuccess) {
  //           this.props.handleSaveEventNickName(this.props.userEventDetails.eventDetailsInfo.eventId, this.newEventName);
  //           this.newEventName = '';
  //           this.warning.setMessage('');
  //         } else {
  //           this.warning.setMessage(response.body.status.errorMessage);
  //         }
  //       });
  //     }
  //   } else {
  //     const eventNameValidationRulesForEmpty = [
  //       { functionRef: commonUtil.isValueAvailable, funcData: [this.newEventName], errorMessage: 'El nombre del evento es obligatorio' },
  //     ];
  //     const validEventNameForEmpty = commonUtil.validateTextInput(eventNameValidationRulesForEmpty, this.eventName, null);
  //     if (validEventNameForEmpty) {
  //       this.props.handleSaveEventNickName(this.props.userEventDetails.eventDetailsInfo.eventId, this.newEventName);
  //       this.newEventName = '';
  //     }
  //   }
  //   if (this.newEventName && this.newEventName === this.props.userEventDetails.eventDetailsInfo.eventName) {
  //     this.cancel();
  //   }
  // }

  updateEventName = () => {
    if (this.newEventName && this.newEventName !== this.props.userEventDetails.eventDetailsInfo.eventName) {
      this.props.handleValidateEventName(this.newEventName, this.email, '').then((response) => {
        if (response.body.status.status === defaultConst.constAPISuccess) {
          this.props.handleSaveEventNickName(this.props.userEventDetails.eventDetailsInfo.eventId, this.newEventName);
          // this.newEventName = '';
          this.warning.setMessage('');
          this.cancel();
        } else {
          this.warning.setMessage(response.body.status.errorMessage);
        }
      });
    } else if (this.newEventName && this.newEventName === this.props.userEventDetails.eventDetailsInfo.eventName) {
      saveEventName(this.props.userEventDetails.eventDetailsInfo.eventId, this.newEventName).then((response) => {
        if (response.body.status.status === defaultConst.constAPIFailure) {
          this.warning.setMessage(response.body.status.errorMessage);
        }
      });
    } else {
      const eventNameValidationRulesForEmpty = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.newEventName], errorMessage: 'El nombre del evento es obligatorio' },
      ];
      const validEventNameForEmpty = commonUtil.validateTextInput(eventNameValidationRulesForEmpty, this.eventName, null);
      if (validEventNameForEmpty) {
        this.props.handleSaveEventNickName(this.props.userEventDetails.eventDetailsInfo.eventId, this.newEventName);
        this.newEventName = '';
      }
    }
    // if (this.newEventName && this.newEventName === this.props.userEventDetails.eventDetailsInfo.eventName) {
    //   this.cancel();
    // }
  }

  cancel = () => {
    document.querySelector('.editEventName').removeAttribute('style');
    if (document.querySelector('.editNameIcon')) {
      document.querySelector('.editNameIcon').removeAttribute('style');
    }
    this.warning.setMessage('');
    if (document.querySelector('.editEventName .formBlock span').textContent) {
      document.querySelector('.editEventName .formBlock span').textContent = '';
      document.querySelector('.editEventName .formBlock .inputMaterial.error').classList.remove('error');
    }
  }
  eventDropDown = () => {
    const dropdown = document.getElementById('dropdown');
    if (dropdown.className === 'dropdown') {
      document.querySelector('#dropdown').classList.add('open');
      this.showDropdown = true;
    } else {
      this.showDropdown = false;
      dropdown.classList.remove('open');
    }
  }
  componentDidMount() {
    if (document.querySelector('.file-upload')) {
      document.querySelector('.file-upload').style.display = 'none';
    }
    const self = this;
    const excludeElement = document.querySelector('.dropdown-menu');
    const addEditLink = document.querySelector('.addEditLink');
    window.addEventListener('click', (event) => {
      if ((excludeElement && excludeElement.contains(event.target)) || (addEditLink && addEditLink.contains(event.target))) {
        return false;
      }
      if (this.showDropdown) {
        self.eventDropDown();
      }
      return false;
    });
  }
  _keepCopyOfTemproryName = (tempEventName) => {
    let eventNameText = tempEventName.target.value;
    eventNameText = eventNameText.replace(/[^a-zA-z0-9ñÑ\s]/gi, '');
    this.newEventName = eventNameText;
    this.eventName.setValue(eventNameText);
  }
  componentWillUnmount() {
    window.removeEventListener('click', () => { });
  }
  getActiveEventInfo = (event) => {
    this.props._getEventDetails(event.eventId);
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'DatosDeMiEvento', eventID: event.eventId }));
  }
  sentenceCase = (str) => {
    if ((str === null) || (str === '')) { return false; }
    const newStr = str.toString();
    return newStr.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }
  handleAllowOnlyAlpha = (e) => {
    const _char = String.fromCharCode(e.charCode);
    if (!(/^[a-zA-z0-9ñÑ\s]+$/.test(_char))) {
      e.preventDefault();
    }
  }
  onPasteFuncOnlyAlpha = (e) => {
    const text = e.clipboardData.getData('Text');
    const alphaNumericValue = text ? text.replace(/[^a-zA-z0-9ñÑ\s]/gi, '') : '';
    if (text !== alphaNumericValue) {
      e.preventDefault();
    }
  }
  render = () => {
    const eventStatusForSuspended = this.props.eventStatusForSuspended;
    const { eventDetailsInfo, lables } = this.props;

    // logic for owner email for validate event name.
    eventDetailsInfo.celebrityInfo.map((data) => {
      if (data.iscoOwner === 'false') {
        this.email = data.email;
      } return false;
    });

    this.eventId = this.props.eventDetailsInfo.eventId;
    const createNewEventLink = {
      cssClass: 'specialLink',
      onClickHandler: this.props.checkEventEligibleToCreate,
    };
    const activeEventsInfo = eventDetailsInfo.activeEventsInfo ? eventDetailsInfo.activeEventsInfo : null;
    const activeEventsList = [];
    /* eslint-disable */
    if (activeEventsInfo) {
      for (const i in activeEventsInfo) {
        activeEventsList.push({
          displayName: activeEventsInfo[i],
          eventId: i,
        });
      }
    }
    /* eslint-enable */
    const cancel = {
      name: 'Cancelar',
      type: 'button',
      value: 'Cancelar',
      disabled: false,
      autoFocus: false,
      style: 'btnSecondaryAction size-Medium',
      onClickHandler: this.cancel,
    };
    const saveEventNickName = {
      name: 'Guardar',
      type: 'button',
      value: 'Guardar',
      disabled: false,
      autoFocus: false,
      style: 'btnPrimaryAction size-Medium m-l-5',
      onClickHandler: this.updateEventName,
    };

    let imageUrl = '';
    if (eventDetailsInfo.imageURL) {
      imageUrl = eventDetailsInfo.imageURL;
    } else {
      imageUrl = commonUtil.getAssetURL() + '/images/addImageIcon.svg';
    }
    return (
      <div>
        <Warning type="error" text={this.warningMessage} ref={wrng => this.wrng = wrng} />
        <div className="col-sm-8 myEventInfo">
          <h1 className="titleSection">{commonUtil.getLabel(lables.eventDetails, 'eventManagement.eventDetails.eventData')}</h1>
          <div className="materialStyle" id="createEvent">
            <div className="imageBlock">
              <div className="imageWrap">
                <img id="croppieImg" className="hover-icon" src={imageUrl} alt="Agregar Archivo" onClick={this.openProfileImageUploader} />
                <label className="uploadIcon"><label className="iClass icon-camara" /></label>
              </div>
              {eventStatusForSuspended === true ? null : <div className="actionUpload">
                <KalturaFileUpload onFileSuccess={this.onFileSuccess} fileAccept="image/*" onFileAddedError={this.onFileAddedError} onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} />
              </div>}
            </div>
          </div>
          <div>
            <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
          </div>

          <div>
            <div className="eventNameBlock">
              <span className="messageText editBlock">Nombre del evento</span>
              <h2 className="displayInline">{this.state.eventName ? this.state.eventName : eventDetailsInfo.eventName}</h2>
              {eventStatusForSuspended === true ? null : <img src={commonUtil.getAssetURL() + '/images/editEventIcon.png'} alt="Agregar Archivo" className="editNameIcon editBlock editEventIcon" id="image" onClick={() => this.openEditBox(eventDetailsInfo.eventName)} />}
              <div className="editEventName">
                <div className="formBlock">
                  <TextInput
                    className="inputMaterial"
                    labelClassName="placeHolderMaterial"
                    htmlId="eventName"
                    label="Nombre del Evento"
                    name={eventDetailsInfo.eventName}
                    value={eventDetailsInfo.eventName}
                    onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                    onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                    required="true"
                    maxlength="30"
                    onChange={e => this._keepCopyOfTemproryName(e)}
                    ref={el => (this.eventName = el)}
                  />
                </div>
                <div className="editEventNameButtons">
                  <InputButton buttonAttr={cancel} />
                  <InputButton buttonAttr={saveEventNickName} />
                </div>
              </div>
            </div>
            <span className="messageText">Fecha del evento</span>
            <p>{eventDetailsInfo.eventDate}</p><span className="messageText">Número de evento</span>
            <p>{eventDetailsInfo.eventId}</p><span className="messageText">Tipo de evento</span>
            <p>{eventDetailsInfo.eventType}</p>
          </div>
        </div>
        <div className="col-sm-4 myEventRight">
          <Link linkJSON={createNewEventLink}>Crear nuevo evento</Link>
          {activeEventsList.length > 0 ? <div id="dropdown" className="dropdown" onClick={this.eventDropDown}>
            <a className="addEditLink" data-target="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{commonUtil.getLabel(lables.editEvent, 'typeof.event')}<i className="icon-flecha_light_abajo" /></a>
            <ul className="dropdown-menu" aria-labelledby="dLabel">
              {activeEventsList.map((event, index) => (
                <li key={index} onClick={() => this.getActiveEventInfo(event)}><a href="javascript:void(0)">{this.sentenceCase(event.displayName)}<i className="icon-flecha_lightsvg_derecha" /></a></li>
              ))}
              <i className="icon-flecha_light_arriba" />
            </ul>
          </div> : null}
        </div>
      </div>
    );
  }
}

